import React,  { useState, useEffect } from 'react' 
import './Sidebar.css'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import CreateIcon from '@mui/icons-material/Create';
import InsertCommentIcon from '@mui/icons-material/InsertComment';
import SidebarOption from './SidebarOption';
import InboxIcon from '@mui/icons-material/Inbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AppsIcon from '@mui/icons-material/Apps';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';
import AddIcon from '@mui/icons-material/Add';
import db from './firebase';
import { useStateValue } from "./StateProvider"

function Sidebar() {
  const [channels, setChannels] = useState([])
  const[{ user }] = useStateValue()


  useEffect(() => {
    // access the database, go inside the collection 'rooms', take a snapshot of the database and give us a new one if it changes. kind of like an event listener for the database. "hey mr. database, give me 'rooms'"
    db.collection('rooms').onSnapshot(snapshot => (
      setChannels(
        snapshot.docs.map(doc => ({
          id:doc.id,
          name: doc.data().name
        }))
      )
    ))      
  }, [])



  return (
    <div className='sidebar'>
        <div className="sidebar__header">
           <div className="sidebar__info">
           <h2>~Wav Pool~</h2>
            <h3>
                <FiberManualRecordIcon />
                {user?.displayName}
            </h3>
           </div>
           <CreateIcon />

        </div>
          {/* <SidebarOption Icon={InsertCommentIcon} title='Threads' noClick={true}/>
          <SidebarOption Icon={InboxIcon} title='Drafts & reactions' />
          <SidebarOption Icon={DraftsIcon} title='Saved items' />
          <SidebarOption Icon={BookmarkBorderIcon} title='Channel browser' />
          <SidebarOption Icon={PeopleAltIcon} title='People & user groups' />
          <SidebarOption Icon={AppsIcon} title='Apps' />
          <SidebarOption Icon={FileCopyIcon} title='File browser' />
          <SidebarOption Icon={ExpandLessIcon} title='Show less' /> */}
          <hr />
          <SidebarOption Icon={AddIcon} addChannelOption title='Add Channel' />
          <SidebarOption Icon={RemoveOutlinedIcon} removeChannelOption title='Remove Channel' />
          <hr />
          <SidebarOption Icon={ExpandMoreIcon} title='Scroll Channels' noClick={true}/>
    

<div className="sidebar__channels">

    {/* for every channels we get back from the database, give us a sidebar component */}
    {channels.map(channel => (
      <SidebarOption className='sidebar__info-channelName' title={channel.name} id={channel.id}/>
    ))}
</div>


    </div>
  )
}

export default Sidebar